import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = {
  class: "card-title d-flex justify-content-between",
  style: {"width":"100%"}
}
const _hoisted_4 = {
  class: "fs-6",
  style: {"color":"lightgray","max-width":"750px"}
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 0,
  style: {"height":"300px"},
  class: "d-flex align-items-center justify-content-center"
}
const _hoisted_7 = {
  key: 1,
  class: "card-body"
}
const _hoisted_8 = { class: "card" }
const _hoisted_9 = { class: "card-body copy-area" }
const _hoisted_10 = { class: "fs-4 mb-4" }
const _hoisted_11 = { class: "fs-4 mb-4" }
const _hoisted_12 = { class: "d-flex fs-4" }
const _hoisted_13 = { class: "me-4" }
const _hoisted_14 = { class: "me-4" }
const _hoisted_15 = { class: "me-4" }
const _hoisted_16 = { class: "me-4" }
const _hoisted_17 = { class: "d-flex fs-4" }
const _hoisted_18 = { class: "me-4" }
const _hoisted_19 = { class: "me-4" }
const _hoisted_20 = { class: "me-4" }
const _hoisted_21 = { class: "me-4" }
const _hoisted_22 = { class: "me-4" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "fs-3 mt-2" }, "Current Positions:", -1)
const _hoisted_24 = { class: "d-flex fs-4" }
const _hoisted_25 = { class: "me-4" }
const _hoisted_26 = { class: "me-4" }
const _hoisted_27 = { class: "me-4" }
const _hoisted_28 = { class: "me-4" }
const _hoisted_29 = { class: "d-flex gap-4" }
const _hoisted_30 = { class: "fs-3 mt-2" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "fs-3 mt-2" }, "Current Price ( bid / ask ):", -1)
const _hoisted_32 = { class: "d-flex fs-4" }
const _hoisted_33 = { class: "me-4" }
const _hoisted_34 = { class: "me-4" }
const _hoisted_35 = { class: "row rol-cols-2 gap-5 mt-5 px-2" }
const _hoisted_36 = { class: "col card" }
const _hoisted_37 = { class: "card-body" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "fs-1 fw-bold mb-4" }, "OPEN LONG", -1)
const _hoisted_39 = { class: "row row-cols-2" }
const _hoisted_40 = {
  class: "fs-2 fw-bold mb-2",
  style: {"color":"#5cb85c"}
}
const _hoisted_41 = { class: "d-flex gap-6" }
const _hoisted_42 = { class: "text-center" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-bold" }, "AVG", -1)
const _hoisted_44 = { class: "fs-4" }
const _hoisted_45 = { class: "text-center" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-bold" }, "LOT", -1)
const _hoisted_47 = { class: "fs-4" }
const _hoisted_48 = { class: "col card" }
const _hoisted_49 = { class: "card-body" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "fs-1 fw-bold mb-4" }, "OPEN SHORT", -1)
const _hoisted_51 = { class: "row row-cols-2" }
const _hoisted_52 = {
  class: "fs-2 fw-bold mb-2",
  style: {"color":"#5cb85c"}
}
const _hoisted_53 = { class: "d-flex gap-6" }
const _hoisted_54 = { class: "text-center" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-bold" }, "AVG", -1)
const _hoisted_56 = { class: "fs-4" }
const _hoisted_57 = { class: "text-center" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-bold" }, "LOT", -1)
const _hoisted_59 = { class: "fs-4" }
const _hoisted_60 = { class: "row rol-cols-2 gap-5 mt-5 px-2" }
const _hoisted_61 = { class: "col card" }
const _hoisted_62 = { class: "card-body" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { class: "fs-1 fw-bold mb-4" }, "CLOSED LONG", -1)
const _hoisted_64 = { class: "row row-cols-2" }
const _hoisted_65 = {
  class: "fs-2 fw-bold mb-2",
  style: {"color":"#5cb85c"}
}
const _hoisted_66 = { class: "d-flex gap-6" }
const _hoisted_67 = { class: "text-center" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-bold" }, "AVG", -1)
const _hoisted_69 = { class: "fs-4" }
const _hoisted_70 = { class: "text-center" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-bold" }, "LOT", -1)
const _hoisted_72 = { class: "fs-4" }
const _hoisted_73 = { class: "text-center" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-bold" }, "PROFIT", -1)
const _hoisted_75 = { class: "fs-4" }
const _hoisted_76 = { class: "col card" }
const _hoisted_77 = { class: "card-body" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("div", { class: "fs-1 fw-bold mb-4" }, "CLOSED SHORT", -1)
const _hoisted_79 = { class: "row row-cols-2" }
const _hoisted_80 = {
  class: "fs-2 fw-bold mb-2",
  style: {"color":"#5cb85c"}
}
const _hoisted_81 = { class: "d-flex gap-6" }
const _hoisted_82 = { class: "text-center" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-bold" }, "AVG", -1)
const _hoisted_84 = { class: "fs-4" }
const _hoisted_85 = { class: "text-center" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-bold" }, "LOT", -1)
const _hoisted_87 = { class: "fs-4" }
const _hoisted_88 = { class: "row rol-cols-2 gap-5 mt-5 px-2" }
const _hoisted_89 = { class: "col card" }
const _hoisted_90 = { class: "card-body" }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("div", { class: "fs-1 fw-bold mb-4" }, "CURRENT LONG", -1)
const _hoisted_92 = { class: "row row-cols-2" }
const _hoisted_93 = {
  class: "fs-2 fw-bold mb-2",
  style: {"color":"#5cb85c"}
}
const _hoisted_94 = { class: "d-flex gap-6" }
const _hoisted_95 = { class: "text-center" }
const _hoisted_96 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-bold" }, "AVG", -1)
const _hoisted_97 = { class: "fs-4" }
const _hoisted_98 = { class: "text-center" }
const _hoisted_99 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-bold" }, "LOT", -1)
const _hoisted_100 = { class: "fs-4" }
const _hoisted_101 = { class: "text-center" }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-bold" }, "SL", -1)
const _hoisted_103 = { class: "fs-4" }
const _hoisted_104 = { class: "text-center" }
const _hoisted_105 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-bold" }, "TP", -1)
const _hoisted_106 = { class: "fs-4" }
const _hoisted_107 = { class: "col card" }
const _hoisted_108 = { class: "card-body" }
const _hoisted_109 = /*#__PURE__*/_createElementVNode("div", { class: "fs-1 fw-bold mb-4" }, "CURRENT SHORT", -1)
const _hoisted_110 = { class: "row row-cols-2" }
const _hoisted_111 = {
  class: "fs-2 fw-bold mb-2",
  style: {"color":"#5cb85c"}
}
const _hoisted_112 = { class: "d-flex gap-6" }
const _hoisted_113 = { class: "text-center" }
const _hoisted_114 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-bold" }, "AVG", -1)
const _hoisted_115 = { class: "fs-4" }
const _hoisted_116 = { class: "text-center" }
const _hoisted_117 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-bold" }, "LOT", -1)
const _hoisted_118 = { class: "fs-4" }
const _hoisted_119 = { class: "text-center" }
const _hoisted_120 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-bold" }, "SL", -1)
const _hoisted_121 = { class: "fs-4" }
const _hoisted_122 = { class: "text-center" }
const _hoisted_123 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-bold" }, "TP", -1)
const _hoisted_124 = { class: "fs-4" }
const _hoisted_125 = { class: "card mt-5" }
const _hoisted_126 = { class: "card-body" }
const _hoisted_127 = /*#__PURE__*/_createElementVNode("div", { class: "fs-1 fw-bold" }, "MetaTrader Summary", -1)
const _hoisted_128 = { class: "row row-cols-2" }
const _hoisted_129 = { class: "col" }
const _hoisted_130 = { class: "d-flex gap-10 mt-4" }
const _hoisted_131 = { class: "fs-2" }
const _hoisted_132 = { style: {"color":"#5cb85c"} }
const _hoisted_133 = { class: "fs-2" }
const _hoisted_134 = { style: {"color":"#5cb85c"} }
const _hoisted_135 = { class: "fs-2" }
const _hoisted_136 = { style: {"color":"#5cb85c"} }

import { ref, inject, computed, onMounted, watch } from "vue";
import AccountService from "@/projects/tenant/modules/accounts/services/AccountService";
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";
import { ElMessage } from "element-plus";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import AccountInjectionKeys from "@/projects/tenant/modules/accounts/types/AccountInjectionKeys";
import filters from "@/core/helpers/filters";

const ACCOUNT_DISPLAY_LIMIT = 10;

export default /*#__PURE__*/_defineComponent({
  __name: 'BriefDetailTradeStatSum',
  props: {
    accountId: {},
    fromBrirfDetail: { type: Boolean },
    accountNumbers: {},
    period: {}
  },
  setup(__props: any) {

const props = __props;



// 内容部分：某平台账号数量超过 10 个时显示 name 而不是账号（复制内容不受影响）
const displaySumAccounts = (value: string): string => {
  const list = (value || "")
    .split(",")
    .map((item) => item.trim())
    .filter((item) => item !== "");
  return list.length > ACCOUNT_DISPLAY_LIMIT
    ? `${props.accountNumbers?.name} (${list.length})`
    : list.join(", ");
};

const isLoading = ref(false);
const data = ref<any>({});
const isSearched = ref(false);
const accountDetail = props.fromBrirfDetail
  ? {}
  : inject(AccountInjectionKeys.ACCOUNT_DETAILS);

const currencyShow = (_balance: any) => {
  return new Intl.NumberFormat().format(_balance);
};

const fetchData = async () => {
  console.log(props.period);
  isSearched.value = true;
  isLoading.value = true;
  console.log(props.accountNumbers.mt4);
  console.log(props.accountNumbers.mt5);

  try {
    const mt4Res = await AccountService.queryTradeStatByAccountNumbers({
      accountNumbers: props.accountNumbers.mt4
        .split(",")
        .map((item) => item.trim())
        .filter((item) => item !== ""),
      from: props.period[0],
      to: props.period[1],
    });

    const mt5Res = await AccountService.queryTradeStatByAccountNumbers({
      accountNumbers: props.accountNumbers.mt5
        .split(",")
        .map((item) => item.trim())
        .filter((item) => item !== ""),
      from: props.period[0],
      to: props.period[1],
    });

    data.value.balance = mt4Res.balance + mt5Res.balance;
    data.value.equity = mt4Res.equity + mt5Res.equity;
    data.value.openTradeStats = mt4Res.openTradeStats.concat(
      mt5Res.openTradeStats
    );
    data.value.closedTradeStats = mt4Res.closedTradeStats.concat(
      mt5Res.closedTradeStats
    );
    data.value.openTrades = mt4Res.openTrades.concat(mt5Res.openTrades);
    data.value.openTradeCurrentPrices = mt4Res.openTradeCurrentPrices.concat(
      mt5Res.openTradeCurrentPrices
    );
  } catch (error) {
    MsgPrompt.error(error);
    isSearched.value = false;
  }
  isLoading.value = false;
};

const copyText = () => {
  let textToCopy = `${props.accountNumbers.mt4
    .split(",")
    .map((item) => item.trim())
    .filter((item) => item !== "")}\n\n`;

  textToCopy += `${props.accountNumbers.mt5
    .split(",")
    .map((item) => item.trim())
    .filter((item) => item !== "")}\n\n`;
  // Add openTradeStats

  data.value.openTradeStats.forEach((item) => {
    textToCopy += `New ${item.cmd == 0 ? "BUY" : "SELL"} ${item.volume} LOT ${
      item.symbol
    } @ AVG: ${item.averagePrice}\n`;
  });
  // Add closedTradeStats
  data.value.closedTradeStats.forEach((item) => {
    textToCopy += `CLOSED ${item.cmd == 0 ? "BUY" : "SELL"} ${
      item.volume
    } LOT ${item.symbol} @ AVG: ${currencyShow(
      item.averagePrice
    )} PL: ${currencyShow(item.profit)}\n`;
  });

  // Add openTrades
  textToCopy += "\nCurrent Positions:\n";

  data.value.openTrades.forEach((item) => {
    // const avgPrice = (item.openPrice + item.closePrice) / 2;
    textToCopy += `${item.cmd == 0 ? "LONG" : "SHORT"} ${item.volume} LOT ${
      item.symbol
    } @ AVG: ${item.averagePrice}\n`;
  });

  // Add equity and balance
  textToCopy += `\nEquity: ${currencyShow(data.value.equity)}\n`;

  // Add openTradeCurrentPrices
  textToCopy += "\nCurrent Price ( bid / ask ):\n";
  data.value.openTradeCurrentPrices.forEach((item) => {
    textToCopy += `${item.symbol}: ${item.bid} / ${currencyShow(item.ask)}\n`;
  });

  // Copy to clipboard
  navigator.clipboard
    .writeText(textToCopy)
    .then(() => {
      ElMessage.success("Copied to clipboard");
    })
    .catch((err) => {
      console.error("Failed to copy text: ", err);
    });
};

watch(
  () => props.period,
  () => {
    fetchData();
  }
);

watch(
  () => props.accountNumbers,
  () => {
    fetchData();
  }
);

onMounted(async () => {
  fetchData();
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, " Search Account: MT4: " + _toDisplayString(displaySumAccounts(props.accountNumbers.mt4)) + " MT5: " + _toDisplayString(displaySumAccounts(props.accountNumbers.mt5)), 1),
          _createElementVNode("div", null, "Search Period: " + _toDisplayString(props.period), 1)
        ]),
        (isSearched.value)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              plain: "",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (copyText())),
              disabled: isLoading.value,
              class: "ms-4"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("action.copy")), 1)
              ]),
              _: 1
            }, 8, ["disabled"]))
          : _createCommentVNode("", true)
      ])
    ]),
    (isSearched.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(ScaleLoader, { color: '#ffc730' })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, " MT4: " + _toDisplayString(displaySumAccounts(props.accountNumbers.mt4)), 1),
                    _createElementVNode("div", _hoisted_11, " MT5: " + _toDisplayString(displaySumAccounts(props.accountNumbers.mt5)), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.openTradeStats, (item) => {
                      return (_openBlock(), _createElementBlock("div", { key: item }, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, "New " + _toDisplayString(item.cmd == 0 ? "BUY" : "SELL"), 1),
                          _createElementVNode("div", _hoisted_14, _toDisplayString(item.volume + " LOT"), 1),
                          _createElementVNode("div", _hoisted_15, _toDisplayString(item.symbol), 1),
                          _createElementVNode("div", _hoisted_16, _toDisplayString("@ AVG: " + item.averagePrice), 1)
                        ])
                      ]))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.closedTradeStats, (item) => {
                      return (_openBlock(), _createElementBlock("div", { key: item }, [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, " CLOSED " + _toDisplayString(item.cmd == 0 ? "BUY" : "SELL"), 1),
                          _createElementVNode("div", _hoisted_19, _toDisplayString(item.volume + " LOT"), 1),
                          _createElementVNode("div", _hoisted_20, _toDisplayString(item.symbol), 1),
                          _createElementVNode("div", _hoisted_21, _toDisplayString("@ AVG: " + item.averagePrice), 1),
                          _createElementVNode("div", _hoisted_22, _toDisplayString("PL: " + currencyShow(item.profit)), 1)
                        ])
                      ]))
                    }), 128)),
                    _hoisted_23,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.openTrades, (item) => {
                      return (_openBlock(), _createElementBlock("div", { key: item }, [
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, _toDisplayString(item.cmd == 0 ? "LONG" : "SHORT"), 1),
                          _createElementVNode("div", _hoisted_26, _toDisplayString(item.volume + " LOT"), 1),
                          _createElementVNode("div", _hoisted_27, _toDisplayString(item.symbol), 1),
                          _createElementVNode("div", _hoisted_28, _toDisplayString("@ AVG: " + item.averagePrice), 1)
                        ])
                      ]))
                    }), 128)),
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, " Equity: " + _toDisplayString(currencyShow(data.value.equity)), 1)
                    ]),
                    _hoisted_31,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.openTradeCurrentPrices, (item) => {
                      return (_openBlock(), _createElementBlock("div", { key: item }, [
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("div", _hoisted_33, _toDisplayString(item.symbol) + ":", 1),
                          _createElementVNode("div", _hoisted_34, _toDisplayString(item.bid) + " / " + _toDisplayString(item.ask), 1)
                        ])
                      ]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _hoisted_38,
                      _createElementVNode("div", _hoisted_39, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.openTradeStats.filter(
                    (item) => item.cmd == 0
                  ), (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: item,
                            class: "col mb-2"
                          }, [
                            _createElementVNode("div", _hoisted_40, _toDisplayString(item.symbol), 1),
                            _createElementVNode("div", _hoisted_41, [
                              _createElementVNode("div", _hoisted_42, [
                                _hoisted_43,
                                _createElementVNode("div", _hoisted_44, _toDisplayString(item.averagePrice), 1)
                              ]),
                              _createElementVNode("div", _hoisted_45, [
                                _hoisted_46,
                                _createElementVNode("div", _hoisted_47, _toDisplayString(item.volume), 1)
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _hoisted_50,
                      _createElementVNode("div", _hoisted_51, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.openTradeStats.filter(
                    (item) => item.cmd == 1
                  ), (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: item,
                            class: "col mb-2"
                          }, [
                            _createElementVNode("div", _hoisted_52, _toDisplayString(item.symbol), 1),
                            _createElementVNode("div", _hoisted_53, [
                              _createElementVNode("div", _hoisted_54, [
                                _hoisted_55,
                                _createElementVNode("div", _hoisted_56, _toDisplayString(item.averagePrice), 1)
                              ]),
                              _createElementVNode("div", _hoisted_57, [
                                _hoisted_58,
                                _createElementVNode("div", _hoisted_59, _toDisplayString(item.volume), 1)
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("div", _hoisted_61, [
                    _createElementVNode("div", _hoisted_62, [
                      _hoisted_63,
                      _createElementVNode("div", _hoisted_64, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.closedTradeStats.filter(
                    (item) => item.cmd == 0
                  ), (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: item,
                            class: "col mb-2"
                          }, [
                            _createElementVNode("div", _hoisted_65, _toDisplayString(item.symbol), 1),
                            _createElementVNode("div", _hoisted_66, [
                              _createElementVNode("div", _hoisted_67, [
                                _hoisted_68,
                                _createElementVNode("div", _hoisted_69, _toDisplayString(item.averagePrice), 1)
                              ]),
                              _createElementVNode("div", _hoisted_70, [
                                _hoisted_71,
                                _createElementVNode("div", _hoisted_72, _toDisplayString(item.volume), 1)
                              ]),
                              _createElementVNode("div", _hoisted_73, [
                                _hoisted_74,
                                _createElementVNode("div", _hoisted_75, _toDisplayString(item.profit), 1)
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_76, [
                    _createElementVNode("div", _hoisted_77, [
                      _hoisted_78,
                      _createElementVNode("div", _hoisted_79, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.closedTradeStats.filter(
                    (item) => item.cmd == 1
                  ), (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: item,
                            class: "col mb-2"
                          }, [
                            _createElementVNode("div", _hoisted_80, _toDisplayString(item.symbol), 1),
                            _createElementVNode("div", _hoisted_81, [
                              _createElementVNode("div", _hoisted_82, [
                                _hoisted_83,
                                _createElementVNode("div", _hoisted_84, _toDisplayString(item.averagePrice), 1)
                              ]),
                              _createElementVNode("div", _hoisted_85, [
                                _hoisted_86,
                                _createElementVNode("div", _hoisted_87, _toDisplayString(item.volume), 1)
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_88, [
                  _createElementVNode("div", _hoisted_89, [
                    _createElementVNode("div", _hoisted_90, [
                      _hoisted_91,
                      _createElementVNode("div", _hoisted_92, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.openTrades.filter(
                    (item) => item.cmd == 0
                  ), (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: item,
                            class: "col mb-2"
                          }, [
                            _createElementVNode("div", _hoisted_93, _toDisplayString(item.symbol), 1),
                            _createElementVNode("div", _hoisted_94, [
                              _createElementVNode("div", _hoisted_95, [
                                _hoisted_96,
                                _createElementVNode("div", _hoisted_97, _toDisplayString((item.openPrice + item.closePrice) / 2), 1)
                              ]),
                              _createElementVNode("div", _hoisted_98, [
                                _hoisted_99,
                                _createElementVNode("div", _hoisted_100, _toDisplayString(item.volume), 1)
                              ]),
                              _createElementVNode("div", _hoisted_101, [
                                _hoisted_102,
                                _createElementVNode("div", _hoisted_103, _toDisplayString(item.sl), 1)
                              ]),
                              _createElementVNode("div", _hoisted_104, [
                                _hoisted_105,
                                _createElementVNode("div", _hoisted_106, _toDisplayString(item.tp), 1)
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_107, [
                    _createElementVNode("div", _hoisted_108, [
                      _hoisted_109,
                      _createElementVNode("div", _hoisted_110, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.openTrades.filter(
                    (item) => item.cmd == 1
                  ), (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: item,
                            class: "col mb-2"
                          }, [
                            _createElementVNode("div", _hoisted_111, _toDisplayString(item.symbol), 1),
                            _createElementVNode("div", _hoisted_112, [
                              _createElementVNode("div", _hoisted_113, [
                                _hoisted_114,
                                _createElementVNode("div", _hoisted_115, _toDisplayString((item.openPrice + item.closePrice) / 2), 1)
                              ]),
                              _createElementVNode("div", _hoisted_116, [
                                _hoisted_117,
                                _createElementVNode("div", _hoisted_118, _toDisplayString(item.volume), 1)
                              ]),
                              _createElementVNode("div", _hoisted_119, [
                                _hoisted_120,
                                _createElementVNode("div", _hoisted_121, _toDisplayString(item.sl), 1)
                              ]),
                              _createElementVNode("div", _hoisted_122, [
                                _hoisted_123,
                                _createElementVNode("div", _hoisted_124, _toDisplayString(item.tp), 1)
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_125, [
                  _createElementVNode("div", _hoisted_126, [
                    _hoisted_127,
                    _createElementVNode("div", _hoisted_128, [
                      _createElementVNode("div", _hoisted_129, [
                        _createElementVNode("div", _hoisted_130, [
                          _createElementVNode("div", _hoisted_131, [
                            _createTextVNode(" Equity: "),
                            _createElementVNode("span", _hoisted_132, _toDisplayString(data.value.equity), 1)
                          ]),
                          _createElementVNode("div", _hoisted_133, [
                            _createTextVNode(" Balance: "),
                            _createElementVNode("span", _hoisted_134, _toDisplayString(data.value.balance), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_135, [
                          _createElementVNode("div", null, [
                            _createTextVNode(" Timestamp: "),
                            _createElementVNode("span", _hoisted_136, _toDisplayString(_ctx.period[1]), 1)
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})